import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

// Fetches the client's CompanyDetails (BC Company Information) once. Use in
// document/print headers to source name, logo, address, bank, registration, etc.
export const useCompany = () => {
  const [company, setCompany] = useState(null);
  useEffect(() => {
    axios.get(`${API}/api/company`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then(r => setCompany(r.data))
      .catch(() => {});
  }, []);
  return company;
};

export default useCompany;
